/**
 * Firebase Configuration
 * 
 * Note: This file has been modified to work with the new firebaseLoader.ts utility.
 * Services are no longer eagerly initialized, but loaded on-demand by the loader.
 * 
 * See src/utils/firebaseLoader.ts for the deferred initialization implementation.
 */

import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';

import { firebaseConfig as generatedConfig } from './firebaseConfigEnv';
import { logger } from './utils/logger';

// Your web app's Firebase configuration
// Use generated config if available, else fall back to environment variables
const firebaseConfig = Object.keys(generatedConfig).length > 0
  ? generatedConfig
  : {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    };

// Initialize Firebase app instance only (no services)
let app: FirebaseApp | undefined;

try {
  // Initialize Firebase only if it hasn't been initialized yet
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
    logger.info("Firebase App Initialized");
  } else {
    app = getApp(); // if already initialized, use that instance
    logger.info("Firebase App Already Initialized");
  }
} catch (error) {
  // Use logger.error, providing context
  const errorMessage = error instanceof Error ? error.message : 'Unknown Firebase Core Initialization Error';
  logger.error(errorMessage, { error, context: 'Firebase Core Initialization' });
}

// Export only the app instance
// Services (analytics, firestore) are loaded dynamically by firebaseLoader.ts
export { app }; 
